// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/layout/Card.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Card({
  as: Component = "section",
  children,
  tone = "primary",
  density = "default",
  interactive = false,
  selected = false,
  className = "",
  ...componentProps
}) {
  return (
    <Component
      {...componentProps}
      className={joinClassNames(
        "oasys-card",
        `oasys-card--${tone}`,
        `oasys-card--${density}`,
        interactive && "oasys-card--interactive",
        selected && "oasys-card--selected",
        className
      )}
    >
      {children}
    </Component>
  );
}
